import { deleteApp, initializeApp } from 'firebase/app'
import { firebaseConfig, firestore } from '../../config/firebase'
import { deleteUser, getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'

export const deleteCreatedUser = async (email, password) => {
  const deleteInstance = initializeApp(firebaseConfig, 'deleteinstance')
  const auth = getAuth(deleteInstance)
  let retryCount = 0;
  const maxRetries = 3;

  while (retryCount < maxRetries) {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password)
      const user = userCredential.user
      await deleteUser(user)
      return true; // Successfully deleted
    } catch (error) {
      console.error(`Attempt ${retryCount + 1} failed:`, error.message)
      retryCount++;
      
      if (retryCount === maxRetries) {
        console.error('Max retry attempts reached. User deletion failed.')
        throw new Error('Failed to delete user after multiple attempts')
      }
      
      // Wait for a short time before retrying
      await new Promise(resolve => setTimeout(resolve, 1000))
    }
  }
  
  // Clean up the app instance
  deleteApp(deleteInstance)
  return false;
}

export const getProfile = async (userdata) => {
  const user = {
    uid: userdata?.uid,
    email: userdata?.email,
    displayName: userdata?.displayName,
    photoURL: userdata?.photoURL
  }
  const userRef = doc(firestore, 'users', user.uid)
  const profileSnap = await getDoc(userRef)
  let profile

  if (!profileSnap.exists()) {
    console.warn('User profile document missing in Firestore, using default profile.', {
      uid: user.uid,
      email: user.email
    })

    // Provide a safe default profile shape to avoid runtime crashes
    profile = {
      user_id: user.uid,
      email: user.email,
      displayName: user.displayName || 'No name',
      photoURL: user.photoURL || '',
      dob: null,
      role: 'standard',
      phone: '',
      nid: '',
      signature: null
    }
  } else {
    profile = profileSnap.data()
  }

  return {
    user,
    profile
  }
}
